// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"styles_switchContainer__HRZN_","switch":"styles_switch__rwp6W"};